export default "__VITE_ASSET__927c7941__"